/**
 * ClassifiedParkingFilter - Фильтр классов парковок
 *
 * ✅ ИСПОЛЬЗУЕТ FILTER TEMPLATES
 * Паттерн: данные фильтра в layerStyles.js, компонент подтягивает через резолвер
 * Поддерживает оба варианта (новый с style/styleKey и старый с items для совместимости)
 */

import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { onChangeClassParkingFilter } from '../../../ac/onChangeMapFilters';
import { CLASSIFIED_PARKING_FILTER } from '../../../constants/filterStyles';
import { getStyleFilterItems } from '../../../constants/filterStylesResolver';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendIconRenderer } from '../../LegendRenderer/LegendIconRenderer';
import styles from '../FilterSidebar.module.css';

const ClassifiedParkingFiltersComponent = ({
    mapFilters,
    onChangeClassParkingFilter,
}) => {
    const filter = CLASSIFIED_PARKING_FILTER;

    // ✅ НОВОЕ: Подтягиваем items через резолвер из стиля
    // Fallback на старую структуру для совместимости
    let items = filter.items;
    if (filter.style && filter.styleKey) {
        items = getStyleFilterItems(filter.style, filter.styleKey);
    }

    const { reduxPath, icon } = filter;

    return (
        <div>
            <div className={styles.legHead}>{i18n._(filter.title)}</div>
            <div className={styles.checkboxIconGrid}>
                {items.map(item => (
                    <Fragment key={item.value}>
                        <LegendIconRenderer
                            type={icon}
                            color={item.color}
                            size="2vw"
                            opacity={0.8}
                        />
                        <label htmlFor={item.value}>{i18n._(item.label)}</label>
                        <div>
                            <label className={styles.switch}>
                                <input
                                    type="checkbox"
                                    name="ClassifiedParkings"
                                    id={item.value}
                                    checked={mapFilters[reduxPath].includes(item.value)}
                                    value={item.value}
                                    onChange={onChangeClassParkingFilter}
                                />
                                <span className={classnames(styles.sliderRound, styles.slider)} />
                            </label>
                        </div>
                    </Fragment>
                ))}
            </div>
        </div>
    );
};

ClassifiedParkingFiltersComponent.propTypes = {
    mapFilters: PropTypes.object.isRequired,
    onChangeClassParkingFilter: PropTypes.func.isRequired,
};

const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeClassParkingFilter })(
    ClassifiedParkingFiltersComponent
);

export const ClassifiedParkingFilter = withDisplayedLayersCheck(
    ConnectedComponent,
    t`Классифицированные парковки`
);
